import { React, useState, useEffect } from 'react'
import { useSearchParams, useParams } from 'react-router-dom';
import DetailInformation from './CompanyDetailInformation';
import Financials from './Filling'
import Tab from '../shared/Tab';
import { baseUrl, getCfsProfileApi } from '../../Config/config';
import axios from 'axios';
import Constants from '../../Constants';
import { useContext } from 'react';
import { UserContext } from '../../Contexts/UserContext';

/**
 * The `CompanyDetail` component is a React component that displays company details, including
 * financial information, and allows the user to switch between different tabs.
 */
const CompanyDetail = () => {

    const financial = () => { document.getElementById("financial").scrollIntoView({ behavior: 'smooth' }); }

    const [isLoading, setIsLoading] = useState(true)
    const [companyProfile, setCompanyProfile] = useState({});
    const [URLSearchParams, 
        // SetURLSearchParams
    ] = useSearchParams({ type: Constants.primaryMasterIds.peId })
    const [isActive, setIsActive] = useState(1);
    const { getToken, logout } = useContext(UserContext);
    const { companyId } = useParams();


    const primaryMasterId = parseInt(URLSearchParams.get('type'))


    const getProfile = () => {
        setIsLoading(true)
        axios(`${baseUrl}/getCompanyProfile`, {
            method: "POST",
            data: {
                company_id: [companyId],
                type: primaryMasterId
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": getToken()
            },
        })
            .then((response) => {
                setIsLoading(false)
                if (response?.data?.success == true) {
                    console.log("setProfileData", response.data);
                    setCompanyProfile(response.data?.data);
                }
            })
            .catch((error) => {
                if (error?.response?.status == Constants.sessionTerminatedStatus) {
                    logout()
                }
                console.log("API not working", error);
            });

    };

    useEffect(() => {
        getProfile();
    }, [])

    const onTabClick = (tabIndex) => {
        if (tabIndex === 1) {
            financial();
        }
        setIsActive(tabIndex);
    }

    // console.log('companyProfile?.topProfile?.fcompanyName', companyProfile?.topProfile?.fcompanyName);

    return (
        isLoading
            ? <>
                <center><div className="w-full bg-[#FFFFFF]">
                    <div role="status" className="bg-white" >
                        <svg className="relative top-[0rem] inline mr-2 w-10 h-screen text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                    </div>
                </div></center>
            </>
            : <>
                <div className="bg-[#FFFFFF]">
                    <DetailInformation data={companyProfile?.topProfile} id={companyId} page="fillingsPage" cname={companyProfile?.topProfile?.company_name} />
                </div>
                <div className="bg-[#EDEDED] h-full">
                    <div className="flex flex-row overflow-x-auto scrollbar space-x-6 bg-white px-6 pt-4  border-b border-[#D7D7D7] cursor-pointer">
                        <Tab active={isActive === 1} label={"Financials"} onClick={() => onTabClick(1)} />
                    </div>
                    <div id="financial"><Financials companyName={companyProfile?.topProfile?.fcompanyName} showAll /> </div>
                </div>
            </>
    )

}

export default CompanyDetail;
